import React, { useMemo } from "react";
import styles from "./teamCalendar.module.scss";
import { KoStaicMembers } from "packages";

const STATUS_COLORS = {
  WFH: "#A58AD4",
  OnDuty: "#D26BB3",
  PaidLeave: "#40C4C1",
  UnpaidLeave: "#CBB892",
  NoAttendance: "#EF6B6B",
  WeeklyOff: "#FEC54C",
  Holiday: "#7AA73A",
  HalfDay: "#4CC3A1"
};

const STATUS_LABELS = {
  WFH: "Work From Home",
  OnDuty: "On Duty",
  PaidLeave: "Paid Leave",
  UnpaidLeave: "Unpaid Leave",
  NoAttendance: "No Attendance",
  WeeklyOff: "Weekly Off",
  Holiday: "Holiday",
  HalfDay: "Half Day"
};

function mapUsers(users) {
  return users?.map((u) => ({
    id: u.userId,
    name: `${u.profile.firstName} ${u.profile.lastName}`,
    logo:u.profile.logo,
    email: u.email,
    firstName: u.profile.firstName,
    lastName: u.profile.lastName,
    days: {}
  }));
}

function genDays(monthLength = 30) {
  return Array.from({ length: monthLength }, (_, i) => i + 1);
}

export default function TeamCalendar({
  users = [],
  leaves = {},
  monthLabel = "Nov 2025",
  monthLength = 30
}) {
  const days = useMemo(() => genDays(monthLength), [monthLength]);

  const team = useMemo(() => {
    const mapped = users && mapUsers(users);
    mapped.forEach((m) => {
      if (leaves[m.id]) m.days = { ...leaves[m.id] };
    });
    return mapped;
  }, [users, leaves]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.monthLabel}>{monthLabel}</div>
        <div className={styles.legend}>
          {Object.keys(STATUS_COLORS).map((k) => (
            <div key={k} className={styles.legendItem}>
              <span
                className={styles.legendDot}
                style={{ backgroundColor: STATUS_COLORS[k] }}
              />
              <span className={styles.legendText}>{STATUS_LABELS[k]}</span>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.weekHeader}>
        <div className={styles.nameHeader}>&nbsp;</div>

        <div className={styles.daysHeader}>
          <div className={styles.weekdayRow}>
            {days.map((_, i) => {
              const weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][i % 7];
              return (
                <div key={i} className={styles.weekdayCell}>
                  {weekday}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className={styles.rowsWrap}>
        {team.map((emp) => (
          <div key={emp.id} className={styles.row}>
            <KoStaicMembers data={emp} />
            <div className={styles.daysScroll}>
              <div className={styles.daysInner}>
                {days.map((day) => {
                  const status = emp.days?.[day];

                  if (!status)
                    return (
                      <div key={day} className={styles.emptyDayCell}>
                        {day}
                      </div>
                    );

                  return (
                    <div
                      key={day}
                      className={styles.statusPill}
                      style={{ backgroundColor: STATUS_COLORS[status] }}
                    >
                      {STATUS_LABELS[status]}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
